module.exports = __webpack_public_path__ + "static/img/r-2-4-icon.702740e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-2/r-2-4-icon.png
// module id = TfJO
// module chunks = 0